export default {
    title: 'list',
    icon: 'UsersIcon',
    route: 'users-list',
    tag: 0,
  }
  